/**
 * Die Dateiauswahl für Bilder (Entscheid 25, 07.10.2026): Layout-Grafiken, Unterschriften
 * und Firmenlogos dürfen SVG, PNG oder JPEG sein. Das `accept` ist Bequemlichkeit, keine
 * Sicherheit — geprüft wird auf dem Server an den Bytes (Magic Bytes, Grösse, Masse) und
 * verbindlich in der Beleg-Engine.
 */
export const BILD_ACCEPT = ".svg,.png,.jpg,.jpeg,image/svg+xml,image/png,image/jpeg";

/** Passt der Dateiname zu einer der drei Arten? (Vorfilter der Auswahl.) */
export function istBildDateiname(name: string): boolean {
  return /\.(svg|png|jpe?g)$/i.test(name);
}
